
import { computed, defineComponent, ref } from "vue";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import gatewayGeneral from "@/components/payment-gateway/gateway-general.vue";
import { Actions } from "@/store/enums/StoreEnums";

export default defineComponent({
  name: "payment-vendor",
  computed: {},
  components: { gatewayGeneral },
  async setup() {
    const store = useStore();
    const router = useRouter();
    const query = ref({ amount: 0 }) as any;
    query.value = router.currentRoute.value.query;

    // Send login request as guest
    await store.dispatch(Actions.LOGIN, {
      mobile: "9585446662",
      password: "ammaappa",
    });
    return { query };
  },
});
